export default "__VITE_ASSET__DuLY6DBf__"